import React, { useEffect } from "react";
import Successfull_Lottie from "../animation/Successfull_Lottie/Successfull_Lottie";
import "./Thank_You.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Confirmation_Message from "./confirmation_message/Confirmation_Message";
import Dpu_alumni from "../home/dpu-alumni/Dpu_alumni";
import Hiring_Partners from "./hiring_partners/Hiring_Partners";

const Thank_You = () => {
  const navigate = useNavigate();

  // useEffect(() => {

  //     if (typeof window.gtag === 'function') {
  //         window.gtag('event', 'conversion', {
  //             send_to: 'AW-16713947906/5GH1COmCs_gaEIK26qE-',
  //             value: 1.0,
  //             currency: 'INR'
  //         });
  //     }
  // }, []);

  useEffect(() => {
    const gtag_report_conversion = (url) => {
      const callback = function() {
        if (typeof url !== "undefined") {
          window.location = url;
        }
      };
      window.gtag &&
        window.gtag("event", "conversion", {
          send_to: "AW-16713947906/L97ZCNrgtfoaEIK26qE-",
          value: 1.0,
          currency: "INR",
          event_callback: callback,
        });
      return false;
    };

    gtag_report_conversion(); // Fire on page load
  }, []);

  return (
    <section className="Thank_You">
      <div className="main_div">
        <Confirmation_Message />
        <div className="thankyou-extra">
          <div className="thankyou-box">
            <h3>What Happens Next?</h3>

            <div className="steps">
              <p>✔ Our counselor will contact you shortly</p>
              <p>✔ Get complete course details</p>
              <p>✔ Personalized career guidance</p>
            </div>
          </div>

          <div className="thankyou-cta">
            <h2>⚡ Want Faster Response?</h2>
            <p>Chat with our counselor instantly on WhatsApp</p>

            <div className="cta-buttons">
              <a
                href="https://wa.me/918956353503?text=Hi%20I%20just%20applied%20for%20DY%20Patil%20Online%20MBA"
                target="_blank"
                rel="noopener noreferrer"
                className="btn whatsapp"
              >
                Chat on WhatsApp
              </a>

              <a href="tel:+918956353503" className="btn call">
                Call Now
              </a>
            </div>
          </div>
        </div>
        <Dpu_alumni />
        <Hiring_Partners />
      </div>

      {/* <div className='container'>
                <div className='main_div'>
                    <div className='lottie_holder'>
                        <Successfull_Lottie />
                    </div>
                    <p className='success_text'>Thank you! Your enquiry has been submitted successfully.</p>
                    <p className='success_text'>We’ll get back to you shortly.</p>
                    <p
                        className='back_text'
                        onClick={() => navigate("/")}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} className='back_icon' /> Back to Home
                    </p>
                </div>
            </div> */}
    </section>
  );
};

export default Thank_You;
